import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { ArriveHome } from './ArriveHome';
import { MyTeamRedirect } from './MyTeamRedirect';

// `/` redirects signed-in team members to their single team page and shows the
// home tiles otherwise; `/home` always shows the tiles. The framework header is
// turned off on both; each page lays out its own content.
export const homeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    PageBlueprint.make({
      name: 'home-root',
      params: {
        path: '/',
        noHeader: true,
        loader: async () => (
          <MyTeamRedirect>
            <ArriveHome />
          </MyTeamRedirect>
        ),
      },
    }),
    PageBlueprint.make({
      name: 'home',
      params: {
        path: '/home',
        noHeader: true,
        loader: async () => <ArriveHome />,
      },
    }),
  ],
});
